/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useState, useCallback} from 'react';
// redux
import {useSelector} from 'react-redux';
// material
import {Emojis, getEmojiIcon} from '../../../../emoji/emojiList'
// styles
import classNames from 'classnames';
import injectSheet from 'react-jss';
import styles from './sentimentshowcase_styles';


/* ========== ~~~~~~~~~~ SENTIMENT SHOWCASE ~~~~~~~~~~ ========== */
const SentimentShowcase = injectSheet(styles)((props) => {
  let {
    branding,
    background,
    primaryText,
    secondaryText,
    isOverview,
  } = props;

  background = `#${background}`
  branding = `#${branding}`
  primaryText = `#${primaryText}`
  secondaryText = `#${secondaryText}`

  return (
    <div
      className={`sentiment-showcase ${props.classes.sentimentshowcase}`}
      style={{background}}
    >
      <div className={'sentiment-title'}>
        <h2 style={{color: isOverview ? secondaryText : primaryText}}>{props.title}</h2>
      </div>
      <div className={'sentiment-counter'} style={{color: secondaryText}}>
        <p style={{color: secondaryText}}>{props.counter}</p>
      </div>
      <div className={'sentiment-emojis'}>
        {Emojis.map((emojiData) => <Item
          key={emojiData.name}
          emojiData={emojiData}
          {...{
            branding,
            background,
            primaryText,
            secondaryText,
            isOverview,
          }} />
        )}
      </div>
    </div>
  );
});

const Item = ({emojiData, branding, primaryText, secondaryText, isOverview}) => {
  const {
    engagement: {
      emojiConfigurations,
    }
  } = useSelector((state) => state);

  const {
    title,
    BLACK_AND_WHITE_3D,
    name,
  } = emojiData;

  const getEmojiConfigByName = useCallback(name =>
      emojiConfigurations?.emojis?.find(e =>
        name?.toLowerCase() === e?.emojiCategory?.emojiName?.toLowerCase()
      ) || {},
    [useCallback?.emojis]
  );

  const [isHoverer, setIsHovered] = useState(false);
  const {
    active,
    emojiCategory: {
      emojiCategoryType,

    } = {},
  } = getEmojiConfigByName(name)

  if (!active) return null;

  return (
    <div
      className={classNames({
        emoji: true,
        overview: isOverview,
      })}
      key={name}
      data-color={branding}
      style={{color: branding}}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className={'emoji-graphic'}>
        <img
          className={'emojiicon'}
          key={name}
          src={isOverview
            ? BLACK_AND_WHITE_3D
            : getEmojiIcon({ emojiName: name, emojiCategoryType})}
        />
      </div>
      <div
        className={'emoji-count'}
        style={{color: isOverview ? secondaryText : (isHoverer ? branding : primaryText)}}>
        {isOverview ? '15%' : '100'}
      </div>
      {!isOverview && <div
        className={'emoji-name'}
        style={{color: isOverview ? secondaryText : (isHoverer ? branding : secondaryText)}}>
        {title || name}
      </div>}
    </div>
  )
}


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default SentimentShowcase;
